export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0
})

export const colors = {
  revenue: '#3AAF71',
  bookings: '#667EEA'
}
